import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "loup",
  "use": "loup-usage",
  "viewBox": "-2.833 132.339 598.112 578.662",
  "content": "<symbol viewBox=\"-2.833 132.339 598.112 578.662\" id=\"loup\"><path d=\"M595.28 657.919L447.407 510.048c75.832-113.749 41.708-265.413-68.248-337.453-109.956-72.041-265.411-45.499-341.243 64.457s-41.708 265.412 68.248 337.453c87.207 56.873 204.746 53.082 288.161-11.375l147.872 147.871 53.083-53.082zM75.832 373.55c0-90.999 75.831-166.831 166.83-166.831 90.998 0 166.83 75.832 166.83 166.831 0 90.998-75.832 166.83-166.83 166.83-90.999 0-166.83-72.041-166.83-166.83z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/loup.svg
// module id = 172
// module chunks = 0